import { useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query';
import { Link, useParams } from 'react-router-dom'
import { acceptInvitation } from '../../api/org';
import { Alert, Button, Container } from 'react-bootstrap';
import SpinnerFullScreen from '../Other/SpinnerFullScreen';

function JoinOrg() {
	const [message, setMessage] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null)
	const {token} = useParams();
	
	const queryClient = useQueryClient();
	const mutation = useMutation(acceptInvitation,
		{
			onSuccess: (data: any) => {
				setMessage(data?.message || "Password reset successfully");
				setError(null);
				queryClient.invalidateQueries('Organizations');
			},
			onError: (error: any) => {
				setMessage(null);
				setError("Something went wrong. Please try again or contact admin.");
			}
		}
	)

	useEffect(()=>{
		if(token) {
			mutation.mutate({token});
			// console.log(resetToken);
		} else {
			setError("Invalid token.");
		}
	}, [token])

	return (
		<Container className="mt-5"  style={{ maxWidth: '500px' }}>
			{mutation.isLoading && <SpinnerFullScreen/>}
			{
				message && <>
				<Alert variant="success">{message}</Alert>
				<Link to="/dashboard/orgs">
					<Button variant='light'>Go to Organizations</Button>
				</Link>

				</>
			}
			{error && <Alert variant="danger">{error}</Alert>}
		</Container>
	)
}

export default JoinOrg